import React from 'react';
import PortButton from '../PortButton';
import { enhancedTheme } from '../utils';

const Server1U = ({
  ports,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'stretch',
      gap: 14,
      width: '100%',
      padding: '4px 8px',
      boxSizing: 'border-box',
    }}
  >
    <div
      style={{
        padding: '12px 10px',
        minWidth: 40,
        background: 'linear-gradient(180deg, #fafafa 0%, #e8e8e8 100%)',
        borderRadius: 4,
        border: '1px solid #bfbfbf',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#434343',
        fontSize: 11,
        fontWeight: 700,
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      1U
    </div>
    <div style={{ flex: 1, paddingRight: 4 }}>
      <div
        style={{
          fontSize: 11,
          color: enhancedTheme.sectionLabel,
          marginBottom: 8,
        }}
      >
        NIC / Port slots
      </div>
      {ports.length === 0 ? (
        <div
          style={{
            padding: '10px 14px',
            background: '#fafafa',
            border: '1px dashed #d9d9d9',
            borderRadius: 4,
            fontSize: 11,
            color: '#8c8c8c',
          }}
        >
          Link Device Registry and add Switch Port Registry rows to show ports
          here.
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {ports.map((port, i) => (
            <PortButton
              key={port._id}
              port={port}
              slotNumber={i + 1}
              selected={String(selectedPortId) === String(port._id)}
              connected={connectedPortIds.has(String(port._id))}
              onClick={onPortClick}
              onRegisterAnchor={onRegisterAnchor}
              size={16}
            />
          ))}
        </div>
      )}
    </div>
  </div>
);

export default Server1U;
